import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { bulkMuteRemoteVideo } from 'features/streaming/actions';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import ConfirmationDialog from 'components/ConfirmationDialog';

const BulkMuteRemoteVideoConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);
  const role = modalData.role as string;
  const displayRoleName = modalData.displayRoleName as string;

  const { hasPermissions } = usePermissions();

  const canMute = hasPermissions(PermissionTypes.remoteMuting, { targetRole: role });

  useEffect(() => {
    if (!canMute) {
      dispatch(closeModal('bulkMuteRemoteVideoConfirmation'));
    }
  }, [canMute, dispatch]);

  const handleCancel = () => {
    dispatch(closeModal('bulkMuteRemoteVideoConfirmation'));
  };

  const handleOk = () => {
    dispatch(bulkMuteRemoteVideo({ roles: [role] }));
    dispatch(closeModal('bulkMuteRemoteVideoConfirmation'));
  };

  return (
    <ConfirmationDialog
      open
      title={t('bulk_mute_remote_video_confirm.title')}
      description={
        <Trans
          i18nKey="modals:bulk_mute_remote_video_confirm.description"
          t={t}
          values={{ role: displayRoleName }}
          components={{ bold: <strong /> }}
        />
      }
      cancelText={t('bulk_mute_remote_video_confirm.btn_cancel_label')}
      okText={t('bulk_mute_remote_video_confirm.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      hideCloseButton
      preventClose
    />
  );
};

export default BulkMuteRemoteVideoConfirmation;
